module.exports = __webpack_public_path__ + "static/media/echoes.d773243d.md";